import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

const baseUriPadre = '/contabilidad/clasificaciones-objeto-gasto/';
const baseURI = 'contabilidad/clasificaciones-objeto-gasto-interno';
const baseURIUnion = 'contabilidad/clasificaciones-objeto-gasto-union/';

/**
 * GET Clasificadores por Objeto del Gasto Union
 * @returns {Promise<object[]>}
 */
export const getClasificadoresObjetoGastoUnion = async () => {
  try {
    const response = await API.get(baseURIUnion);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * GET Clasificadores por Objeto del Gasto
 * @returns {Promise<object[]>}
 */
export const getClasificadoresObjetoGasto = async () => {
  try {
    const response = await API.get(baseUriPadre);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * GET Clasificadores por Objeto del Gasto Interno
 * @returns {Promise<object[]>}
 */
export const getClasificadoresObjetoGastoInternos = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * GET Clasificador por Objeto del Gasto Interno
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getClasificadorObjetoGastoInterno = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Clasificador por Objeto del Gasto Interno
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClasificadorObjetoGastoInterno = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Clasificador por Objeto del Gasto Interno
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchClasificadorObjetoGastoInterno = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Clasificador por Objeto del Gasto Interno
 * @param {number} id
 * @returns {Promise<boolean>}
 */

export const deleteClasificadorObjetoGastoInterno = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
